"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.InvalidRelay = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const openapi_1 = require("../../../openapi");
const PelicanBridge = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.PubSub.PelicanBridge.Spec';
exports.InvalidRelay = openapi_1.Error.v1Rejected(`${exports.NAMESPACE}.InvalidRelay`, 'INVALID_REQUEST', 'Invalid Relay Request', 'The body has no usable device id or no message object, or the device id does not start with PLCN. Carries no field errors.');
const relayMessage = platform_1.HttpApiEndpoint.post('relayMessage') `/relay`
    .setPayload(PelicanBridge.RelayPayload)
    .addSuccess(openapi_1.Response.EmptyData)
    .addError(exports.InvalidRelay)
    .annotate(platform_1.OpenApi.Title, 'Relay Pelican Message')
    .annotate(platform_1.OpenApi.Description, 'Temporary bridge: relays a command from the Pelican API to a Pelican device through its instantMessage method. Only ids that start with PLCN, in any letter case, are accepted. A 200 does not mean the device accepted the command: when the device answers with an error status the answer to this call is still 200. When the device cannot be reached, is not connected or is unknown, the call fails and the answer is 500 UNKNOWN_ERROR, never 404.')
    .pipe(openapi_1.Error.withErrors([openapi_1.Error.V1RateLimit, openapi_1.Error.V1Internal]));
exports.Spec = platform_1.HttpApiGroup.make('v1.pubsub.pelicanbridge')
    .middleware(openapi_1.Security.V1ServerToServer)
    .add(relayMessage)
    .prefix('/pubsub/pelicanbridge')
    .annotate(platform_1.OpenApi.Title, 'PubSub Pelican Bridge')
    .annotate(platform_1.OpenApi.Description, 'Server-to-server callback of the Pelican API. Not published in the audience documents.');
//# sourceMappingURL=spec.js.map